module.exports = __webpack_public_path__ + "static/media/power-capital.9464b3e6.png";